import { PackagePickerApiClient } from '../../providers';
import { useQueryParams } from '../useQueryParams';
import { useSiteGuid } from '../useSiteGuid';
export const useProducts = _ref => {
  let {
    packagePickerType,
    sortType = 'desc'
  } = _ref;
  let data;
  const siteGuid = useSiteGuid();
  const {
    useOffering
  } = PackagePickerApiClient.hooks;
  const {
    isChangePlan
  } = useQueryParams();
  const {
    data: offeringData,
    isLoading,
    isError,
    error,
    isSuccess
  } = useOffering({
    packagePickerType,
    isChangePlan,
    siteGuid
  });
  const productInfos = offeringData == null ? void 0 : offeringData.products.filter(p => p.productId);
  if (productInfos) {
    if (sortType === 'desc') {
      data = productInfos.sort((p1, p2) => p2.order - p1.order);
    }
    if (sortType === 'asc') {
      data = productInfos.sort((p1, p2) => p1.order - p2.order);
    }
  }
  return {
    data,
    isLoading,
    isSuccess,
    isError,
    error
  };
};
//# sourceMappingURL=useProducts.js.map